/** Notes Icon with count badge — mirrors ChatBadge for the right-rail Notes tool. */
import { Note as NoteIcon } from '@tunasong/icons'
import type { IconProps } from '@tunasong/icons'
import type { FC } from 'react'
import styles from './notes-badge-icon.module.css'

interface NotesBadgeProps extends IconProps {
  count: number
}

export const NotesBadge: FC<NotesBadgeProps> = ({ count, ...restProps }) =>
  count > 0 ? (
    <span className={styles.wrapper}>
      <NoteIcon {...restProps} />
      <span className={styles.badge}>{count}</span>
    </span>
  ) : (
    <NoteIcon {...restProps} />
  )
